import type {ReactNode} from "react";

import {cn} from "@project/design-system-web";

export interface PageSubContainerSkeletonProps {
  children: ReactNode;
  className?: string;
}

export function PageSubContainerSkeleton({children, className}: PageSubContainerSkeletonProps) {
  return (
    <div
      className={cn("@container flex h-full min-h-0 flex-1 flex-col gap-4 @lg:gap-6", className)}
    >
      {children}
    </div>
  );
}
